<template>
  <div class="container">

    <!--  头部条-->
    <div class="topContainer">
      <div class="topContainer_inner">
        <div
            class="goIndexBtn" @click="goHome"  v-tracking="{module:'xsd_pdf',actionName: $trackConfig['xsd_pdf_goHome'],actionCode:'xsd_pdf_goHome'}">回到标书对比首页
        </div>
        <div style="flex: 1;"></div>
        <div class="exportBtn" style="width:80px;margin-right:12px;" @click="openFeedback">评价反馈</div>
        <div  class="exportBtn" @click="export_result"  v-tracking="{module:'xsd_pdf',actionName: $trackConfig['xsd_pdf_export'],actionCode:'xsd_pdf_export'}">导出
        </div>
      </div>
    </div>
    <div class="mainContainer">
      <div class="mainInner">
        <div class="muluContainer">
          <div :class="{activeTag:showSummery}" class="tagContainer" @click="showSummery = true">
            <span>结果总览</span>
          </div>
          <div v-for="(item,idx) in allTags" :key="idx"
               :class="{activeTag:(item.org_name == currentTagKey)&& !showSummery }"
               class="tagContainer"
               @click="changeTag(item)">
            <span>{{ item.org_name }}</span>
            <span v-if="true" style="margin-left: 10px;">
            <span v-if="( item.totalSim  == 0)" class="green" style="font-size: 12px">(正常)</span>
            <span v-else style="font-size: 12px">  <span class="red">({{ item.totalSim }})</span>个异常</span>
          </span>
            <span v-else style="position:absolute;right: 4px;">
            <i class="el-icon-loading" style="margin-right:10px;color: #224AE3;"></i>
          </span>
          </div>
        </div>
        <div class="contentContainer">
          <div  v-if="showSummery" style="flex:1;display: flex;flex-direction: column;">
            <div class="title_withLine" style="margin-bottom: 20px;">标书对比报告</div>
            <el-descriptions :column="2" size="medium" style="padding:15px 20px;background: #eee;">
              <el-descriptions-item label="待查文档数量">{{ evaluationData.file_amount }}份</el-descriptions-item>
              <el-descriptions-item label="提取段落个数">{{ evaluationData.total_para_amount }}个</el-descriptions-item>
              <el-descriptions-item label="开始时间">{{ evaluationData.start_time }}</el-descriptions-item>
              <el-descriptions-item label="检查结果"> <span v-if="true">检查成功且揪出异常内容</span><span v-else>本次检查不扣费</span></el-descriptions-item>
              <el-descriptions-item label="提取表格个数">{{ evaluationData.total_table_amount }}个</el-descriptions-item>
              <el-descriptions-item label="提取总文字数">{{ evaluationData.total_words_amount }}字</el-descriptions-item>
              <el-descriptions-item label="文档交叉组合">{{ evaluationData.file_groups }}种</el-descriptions-item>
              <el-descriptions-item :span="2" label="预计段落组合">{{
                  evaluationData.para_groups
                }}个
              </el-descriptions-item>
            </el-descriptions>
            <div style="flex:1;margin-top: 20px;">
              <el-table
                  :data="allTags"
                  :header-cell-style="{
                    color: '#000',
                    height: '48px',
                  }"
                  height="250"
                  style="border: 1px solid #eee">
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="left"
                    header-align="left"
                    label="序号"
                    type="index">

                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="left"
                    header-align="left"
                    label="投标单位"
                    prop="org_name"
                >

                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="left"
                    header-align="left"
                    label="检查状态"
                >
                  <template slot-scope="scope">
                    <span style="color: green;">检查完成</span>
                  </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="left"
                    header-align="left"
                    label="文本相似数量"
                >
                  <template slot-scope="scope">
                    <span style="color: red;">
                      {{scope.row.sim_num}}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column
                    v-if="hasImg"
                    :show-overflow-tooltip="true"
                    align="left"
                    header-align="left"
                    label="图片相似数量"
                >
                  <template slot-scope="scope">
                    <span style="color: red;">
                      {{scope.row.pictures_sims?scope.row.pictures_sims:0}}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column
                    v-if="hasAuthor"
                    :show-overflow-tooltip="true"
                    align="left"
                    header-align="left"
                    label="作者相似数量"
                >
                  <template slot-scope="scope">
                    <span style="color: red;">
                      {{scope.row.author_sim?scope.row.author_sim:0}}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column
                    v-if="hasErrText"
                    :show-overflow-tooltip="true"
                    align="left"
                    header-align="left"
                    label="错别字数量"
                >
                  <template slot-scope="scope">
                    <span style="color: red;">
                      {{scope.row.error_write_sims?scope.row.error_write_sims:0}}
                    </span>
                  </template>
                </el-table-column>
<!--                <el-table-column-->
<!--                    v-if="hasImg"-->
<!--                    :show-overflow-tooltip="true"-->
<!--                    align="left"-->
<!--                    header-align="left"-->
<!--                    label="图片相似数量"-->
<!--                >-->
<!--                  <template slot-scope="scope">-->
<!--                    <span style="color: red;">-->
<!--                      {{scope.row.sim_img_count}}-->
<!--                    </span>-->
<!--                  </template>-->
<!--                </el-table-column>-->
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="left"
                    header-align="left"
                    label="操作"
                >
                  <template slot-scope="scope">
                    <span style="color: #3491F9;cursor: pointer" @click="changeTag(scope.row)">
                     查看
                    </span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div v-else style="flex:1;height: 1px;">
            <el-table :data="currentTagData.details"
                      border
                      stripe
                      style="width: 100%"
                      height="300px"
                   >
<!--              <el-table-column type="expand" width="48px">-->
<!--                <template slot-scope="scope">-->
<!--                  <div style="box-sizing: border-box;background-color: #F4F7FC;height: 400px;" >-->
<!--                    <el-table-->
<!--                        :data="scope.row.sims"-->
<!--                        :header-cell-style="{-->
<!--                            background: '#F4F7FC',-->
<!--                            color: '#8C8C8C',-->
<!--                          }"-->
<!--                        class="expandTable"-->
<!--                        style="border: 1px solid #eee"-->
<!--                        height="300px"-->
<!--                    >-->
<!--                      <el-table-column width="48px;"></el-table-column>-->
<!--                      <el-table-column-->
<!--                          :show-overflow-tooltip="true"-->
<!--                          align="left"-->
<!--                          header-align="left"-->
<!--                          label="序号"-->
<!--                          type="index"-->
<!--                      >-->
<!--                      </el-table-column>-->
<!--                      <el-table-column-->
<!--                          :show-overflow-tooltip="true"-->
<!--                          align="left"-->
<!--                          header-align="left"-->
<!--                          label="基准文件"-->
<!--                          prop="mulu"-->
<!--                      >-->
<!--                      </el-table-column>-->
<!--                      <el-table-column-->
<!--                          :show-overflow-tooltip="true"-->
<!--                          align="left"-->
<!--                          header-align="left"-->
<!--                          label="相似单位"-->
<!--                          prop="cont_name"-->
<!--                      >-->
<!--                      </el-table-column>-->
<!--                      <el-table-column-->
<!--                          :show-overflow-tooltip="true"-->
<!--                          align="left"-->
<!--                          header-align="left"-->
<!--                          label="相似文件"-->
<!--                          prop="cont_mulu"-->
<!--                      >-->
<!--                      </el-table-column>-->
<!--                      <el-table-column-->
<!--                          :show-overflow-tooltip="true"-->
<!--                          align="left"-->
<!--                          header-align="left"-->
<!--                          label="相似字数"-->
<!--                          prop="sim_word_num"-->
<!--                          width="80px"-->
<!--                      >-->
<!--                        <template slot-scope="scope">-->
<!--                          <span class="red">{{ scope.row.sim_word_num }}</span>-->
<!--                        </template>-->
<!--                      </el-table-column>-->
<!--                      <el-table-column-->
<!--                          align="left"-->
<!--                          header-align="left"-->
<!--                          label="操作"-->
<!--                          width="60px"-->
<!--                      >-->
<!--                        <template slot-scope="scope">-->
<!--                          <div-->
<!--                              style="color: rgb(27, 111, 190);cursor: pointer"-->
<!--                              @click="showDetail(currentTagKey, scope.row)"-->
<!--                              v-tracking="{module:'xsd_pdf',actionName: $trackConfig['xsd_pdf_detail'],actionCode:'xsd_pdf_detail'}"-->
<!--                          >查看-->
<!--                          </div>-->
<!--                        </template>-->
<!--                      </el-table-column>-->
<!--                    </el-table>-->
<!--                  </div>-->
<!--                </template>-->
<!--              </el-table-column>-->
              <el-table-column
                  :show-overflow-tooltip="true"
                  align="left"
                  header-align="left"
                  label="检查类型"
                  width="100px"
              >
                <template slot-scope="scope">
                  {{ scope.row.category == 1 ? '招标相似项' : '投标异常项' }}
                </template>
              </el-table-column>
              <el-table-column
                  :show-overflow-tooltip="true"
                  align="left"
                  header-align="left"
                  label="基准文件"

              >
                <template slot-scope="scope">
                  {{ scope.row.mulu }}
                </template>
              </el-table-column>
              <el-table-column
                  :show-overflow-tooltip="true"
                  align="left"
                  header-align="left"
                  label="目标文件"

              >
                <template slot-scope="scope">
                  {{ scope.row.cont_name + "—" + scope.row.cont_mulu }}
                </template>
              </el-table-column>
              <el-table-column
                  :show-overflow-tooltip="true"
                  align="left"
                  header-align="left"
                  label="文本异常数量"
                  width="100px"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.sims.length" class="red">{{ scope.row.sims.length }}</span>
                  <span v-else class="green">0</span>
                </template>
              </el-table-column>
              <el-table-column
                  v-if="hasImg"
                  :show-overflow-tooltip="true"
                  align="left"
                  header-align="left"
                  label="图片异常数量"
                  width="100px"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.pictures_sims.length" class="red">{{ scope.row.pictures_sims.length }}</span>
                  <span v-else class="green">0</span>
                </template>
              </el-table-column>
              <el-table-column
                  v-if="hasAuthor"
                  :show-overflow-tooltip="true"
                  align="left"
                  header-align="left"
                  label="作者异常数量"
                  width="100px"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.auth_sim.length" class="red">{{ scope.row.auth_sim.length }}</span>
                  <span v-else class="green">0</span>
                </template>
              </el-table-column>
              <el-table-column
                  v-if="hasErrText"
                  :show-overflow-tooltip="true"
                  align="left"
                  header-align="left"
                  label="错别字数量"
                  width="100px"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.error_write_sims.length" class="red">{{ scope.row.error_write_sims.length }}</span>
                  <span v-else class="green">0</span>
                </template>
              </el-table-column>
              <el-table-column
                  :show-overflow-tooltip="true"
                  align="left"
                  header-align="left"
                  label="相似字数"
                  width="80px"
              >
                <template slot-scope="scope">
                  <template>
                    <span v-if="scope.row.sim_word_num" class="red">{{ scope.row.sim_word_num }}</span>
                    <span v-else class="green">0</span>
                  </template>
                </template>
              </el-table-column>
              <el-table-column
                  :show-overflow-tooltip="true"
                  align="left"
                  header-align="left"
                  label="相似比例"
                  width="80px"
              >
                <template slot-scope="scope">
                  <template>
                    <span  class="red" v-if="scope.row.base_word_amount">{{ (((scope.row.word_sim_amount / scope.row.base_word_amount)*100).toFixed(2)) >100?100:(((scope.row.word_sim_amount / scope.row.base_word_amount)*100).toFixed(2)) +'%' }}</span>
                    <span class="red" v-else>--</span>
                  </template>
                </template>
              </el-table-column>
              <el-table-column
                align="left"
                header-align="left"
                label="操作"
                width="60px"
                >
                <template slot-scope="scope">
                  <div
                      style="color: rgb(27, 111, 190);cursor: pointer"
                      @click="showDetail(currentTagKey, scope.row)"
                      v-tracking="{module:'xsd_pdf',actionName: $trackConfig['xsd_pdf_detail'],actionCode:'xsd_pdf_detail'}"
                  >查看
                  </div>
                </template>
                </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
    <detail
        v-if="visible"
        :tagKey="currentTagKey"
        :visible="visible"
        :companyList="companyList"
        @close="close"
    ></detail>
    <FeedbackDialog ref="feedbackDialogRef"></FeedbackDialog>
  </div>
</template>

<script>
import {getExportFile} from "@/api/common"
import {getCompanyList, getCompanyDataByName,getOrgSim} from "@/api/pdf";
import {getResultHead} from "@/api/common";
import {mapMutations, mapState} from "vuex";
import detail from "@/views/pdf/detail";

import FeedbackDialog from "@/views/pdf/FeedbackDialog";

export default {
  name: "result",
  components:{
    detail,
    FeedbackDialog
  },
  data() {
    return {
      companyList: [],
      deduction: false,
      // 当前选中的标签
      currentTagKey: "",
      deductionNumber:0,
      // 当前选中标签下的数据 相似度数据
      currentTagData: {},
      showSummery: true,
      visible: false,
      simIdx: 0,
    }
  },
  async mounted() {
     await this.getCompanyList();
     await this.getResultHead();
  },
  methods: {
    openFeedback(){
      this.$refs.feedbackDialogRef.open();
    },
    /**
     * 回首页
     */
    goHome(){
      this.$router.push({
        name:"Home",
        params:{
          init:true
        }
      })
    },
    /**
     *
     * 导出
     */
    async export_result(){
      // this.checkDeductionInfo(2)
      let res = await getExportFile({
        project: this.projectId,
        sign_name: this.sign_name
      });
      let url = res.data;
      this.$util.downloadExportUrl(url, this.checkName);

    },
    /**
     * 获取企业列表
     * @returns {Promise<void>}
     */
    async getCompanyList() {
      let res = await getOrgSim({
        project: this.projectId,
        sign_name: this.sign_name
      });
      this.companyList = res.data;
      this.companyList = this.$_.sortBy(this.companyList, 'org_name');
      this.currentTagKey = this.allTags[0].org_name;
    },

    /**
     * 获取企业对应的数据
     */
    async getCompanyDataByName() {
      let res = await getCompanyDataByName({
        project: this.projectId,
        sign_name: this.sign_name,
        org_name:this.currentTagKey
      });

      this.$_.each(res.data.details, (item) => {
        this.$_.each(item.sims, (_item) => {
          _item.mulu = item.mulu;
          _item.cont_mulu = item.cont_mulu;
          _item.name = item.name;
          _item.cont_name = item.cont_name;
        })
      })
      this.currentTagData = res.data;
      console.log(this.currentTagData,999999)
    },
    /**
     * 切换单位
     * @param tag
     */
    changeTag(tag){
      this.showSummery = false;
      this.currentTagKey = tag.org_name;
    },

    /**
     * 查看详情
     */

    async checkDeductionInfo(type){
      let res = await checkDeduction({
        project: this.projectId,
        sign_name: this.sign_name
      });

      if(res.data){
        if(type == 1){
          this.visible = true
        }else if(type == 2){
          let res = await getExportFile({
            project: this.projectId,
            sign_name: this.sign_name
          });
          let url = res.data;
          this.$util.downloadExportUrl(url, this.checkName);
        }
      }else{
        await this.$router.push("/pdfMiddleResult");
      }
    },
    showDetail(key, item){
      // this.checkDeductionInfo(1)
      this.visible = true
    },
    close() {
      this.visible = false
    },

    /**
     * 获取检查参数
     */
    async getResultHead(){
      let res = await getResultHead({
        project: this.projectId,
        sign_name: this.sign_name
      });
      this.deduction = res.data.deduction;
      this.deductionNumber = res.data?.projectInfo?.deductionNumber ?  res.data?.projectInfo?.deductionNumber:1;
      let flag_setting = res.data?.resultHead?.flag_setting?res.data?.resultHead?.flag_setting:{};
      if(flag_setting['check_author'] == 1){
        this.setHasAuthor(true)
      }else{
        this.setHasAuthor(false)
      }
      if(flag_setting["error_write"] == 1){
        this.setHasErrText(true)
      }else{
        this.setHasErrText(false)
      }

      if(flag_setting["picture_sim"] == 1){
        this.setHasImg(true)
      }else{
        this.setHasImg(false)
      }
    },
    ...mapMutations("pdf",['setHasImg','setHasAuthor','setHasPara','setHasErrText'])
  },
  computed: {
    ...mapState('pdf', ['projectId', 'sign_name','checkName','evaluationData','hasImg','hasErrText','hasAuthor']),
    allTags() {
      let companyListInfo = this.$_.sortBy(this.companyList, 'org_name').map(item=>{
        item.totalSim = item.sim_num + item.author_sim + item.pictures_sims;
        return item;
      })

      return companyListInfo;
    },
  },
  watch: {
    /**
     * 监听currentTag查询获取数据
     */
    currentTagKey: {
      async handler(val) {
        if (val) {
          await this.getCompanyDataByName();
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  flex: 1;
  height: 1px;
  display: flex;
  flex-direction: column;
}

.topContainer {
  background-image: url("~@/assets/image/topbg.png");
  background-repeat: no-repeat;
  height: 56px;

  &_inner {
    width: $innerWidth;
    height: 100%;
    margin: 0 auto;
    display: flex;
  }
}

.mainContainer {
  flex: 1;
  height: 1px;
  background-image: url("~@/assets/image/indexbg1.png"), url("~@/assets/image/indexbg.png");
  background-size: auto auto, 100% 100%;
  background-repeat: no-repeat;
  background-color: #fff;
  display: flex;
  flex-direction: column;

  .mainInner {
    flex: 1;
    height: 1px;
    width: $innerWidth;
    margin: 10px auto;
    box-sizing: border-box;
    display: flex;
    background: #fff;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
  }
}

.muluContainer {
  width: 200px;
  font-size: 14px;
  font-weight: bold;
  height: 100%;
  overflow: auto;
  box-sizing: border-box;

  .tagContainer {
    height: 56px;
    line-height: 56px;
    cursor: pointer;
    border-bottom: 1px solid #ddd;
    padding-left: 10px;
    display: flex;
    color: #000;
    position: relative;
    font-size: 14px;
    font-weight: normal;
  }

  .activeTag {
    font-weight: bold;
    background-color: #fff;
    color: #224AE3;
    font-size: 14px;

    &::before {
      content: "";
      width: 2px;
      height: 100%;
      background: #224AE3;
      position: absolute;
      left: 0px;
    }

    &::after {
      content: "";
      height: 100%;
      width: 10px;
      background-repeat: no-repeat;
      background-position: center;
      background-image: url("~@/assets/image/right.png");
      position: absolute;
      right: 5px;
    }
  }
}

.contentContainer {
  flex: 1;
  background-color: #fff;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  padding: 15px 25px;
  font-size: 14px;
  overflow: auto;
  display: flex;
  flex-direction: column;
}
.title_withLine {
  height: 30px;
  line-height: 30px;
  font-weight: bold;
  box-sizing: border-box;
  position: relative;
  padding-left: 15px;
  &::before {
    content: "";
    display: block;
    width: 5px;
    height: 20px;
    background: #3D7EF7;
    position: absolute;
    left: 0px;
    top: 5px;
  }
}
.exportBtn{
  width: 60px;
  height: 28px;
  font-size: 14px;
  border: 1px solid rgba(34, 74, 227, 1);
  margin-top: 13px;
  text-align: center;
  line-height: 28px;
  background-color: #fff;
  cursor: pointer;
  border-radius: 4px;
  color: #224AE3;
}
.goIndexBtn {
  line-height: 56px;
  font-size: 14px;
  background-image: url("~@/assets/image/shouye.png");
  background-repeat: no-repeat;
  background-size: 16px;
  background-position: 0px center;
  padding-left: 25px;
  cursor: pointer;
}
.red {
  color: #FF5D3F;
}

.green {
  color: #2AC09B;
}
</style>
